module.exports = __webpack_public_path__ + "img/con_10.c112f41e.svg";